import React from 'react';
import { useStyles } from './Step.styles';
import { Grid, useTheme } from '@mui/material';
import TextRender from 'components/Global/TextRender/TextRender';

export interface IStep {
  stepNumber?: number;
  isEnabled: boolean;
  sectionName: string;
  caption?: string;
  isPartial?: boolean;
  children?: JSX.Element;
}
export function Step({
  isEnabled,
  stepNumber,
  isPartial,
  sectionName,
  children,
  caption,
}: IStep): JSX.Element {
  const classes = useStyles();
  const theme = useTheme();
  const isHondaTheme = theme.themeName === 'honda';
  const stepDisabledClass = classes.stepDisabled;
  const stepTitlePartialClass = classes.stepTitlePartial;
  return (
    <Grid
      container
      className={`step ${!isEnabled && 'is-disabled'}`}
      direction="row"
    >
      <Grid className={`${classes.root}`} container direction="row">
        {stepNumber && (
          <span
            className={`${classes.stepNumber} acr-title-4 ${
              !isEnabled && stepDisabledClass
            }`}
          >
            {stepNumber}
          </span>
        )}
        <TextRender
          tagName="h2"
          className={`${classes.stepTitle} ${
            isPartial && stepTitlePartialClass
          } ${!isEnabled && stepDisabledClass} ${
            isHondaTheme && isPartial ? 'atm-caption-5' : 'acr-caption-6'
          }`}
          text={sectionName}
        />

        {caption && (
          <span
            className={`${classes.stepCaption} acr-paragraph-8 step-caption`}
          >
            {caption}
          </span>
        )}
      </Grid>
      {children && (
        <Grid
          className={`${classes.stepContent} step-container`}
          container
          direction="row"
        >
          {children}
        </Grid>
      )}
    </Grid>
  );
}
